import React,{useContext} from "react";
import "./LmsCaseStudy.css"; 
import Lms_Sys from "../../Assets/lmssys.png";

import Lms_DB from "../../Assets/lmsdb.png";

import { ThemeContext } from "../../../contexts/theme";
import Footer from "../../Footer/Footer";

const NinjaCaseStudy = () => {
  const [{ themeName }] = useContext(ThemeContext);

  return (
    <div className={`ninja-container ${themeName === 'dark' ? 'dark' : ''}`}>
      <a style={{ padding: "6px", display: "inline-block", border: "1px solid" }} href="/">
        Go Back
      </a>
      <h1 className="ninja-title">LMS Case Study</h1>

    {/* Project Description */}
    <section className="ninja-section">
      <h2>Project Overview</h2>
      <p>
       <strong>ELearning LMS</strong>is a Learning Management System (LMS) built with Next.js and TypeScript on the client for an SEO friendly and smooth user experience, paired with a robust Node.js/Express backend for core services. Admins can create and publish courses that learners can purchase and enroll in via a secure payment gateway (Stripe).
Learners can watch course videos through an integrated video player, access supporting materials from a dedicated resources section for each lesson, and actively engage by posting questions tied to specific sections. Users can also share feedback through course reviews, fostering a collaborative learning environment. Sign up and sign in are streamlined with Google OAuth and GitHub OAuth.
The platform includes a dedicated admin dashboard to manage courses and orders, view and moderate users, assign team moderators, and review analytics. From this dashboard, admins can also dynamically configure layout components such as the Hero section, FAQs, and Categories so the site can evolve without code changes.
      </p>
    </section>

    {/* Video */}
    <section className="ninja-section">
      <h2>Video Demonstration</h2>
      <div className="ninja-video">
        <iframe
  width="100%"
  height="400"
  src="https://www.youtube.com/embed/Jwwn5xIwdBA?si=RQ8zh0Y-S9nG4Ryh"
  title="LMS Demo"
  frameBorder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowFullScreen
></iframe>

      </div>
    </section>

    {/* Tech Stack */}
    <section className="ninja-section">
      <h2>Tech Stack</h2>
      <ul className="ninja-list">
        <li><strong>Frontend:</strong> React, Tailwind CSS</li>
        <li><strong>Editor:</strong> VS Code</li>
        <li><strong>Storage:</strong> LocalStorage</li>
        <li><strong>Deployment:</strong> vercel</li>
      </ul>
    </section>

    {/* Features & Challenges */}
    <section className="ninja-section ninja-features">
      <div style={{ display: "flex", gap: "2.5rem", flexWrap: "wrap" }}>
        <div style={{ flex: "1 1 45%" }}>
          <h3>🛠️ Features</h3>
          <ul className="ninja-list">
           <li>Real-time  preview for instant learning feedback</li>
<li>Search, browse, and filter courses by category</li>
<li>Secure Stripe checkout with multiple wallet options</li>
<li>Profile management: password, avatar, purchased courses</li>

          </ul>
        </div>
        <div style={{ flex: "1 1 45%" }}>
          <h3>⚠️ Challenges & Solutions</h3>
          <ul className="ninja-list">
           <li>🔄 Real-time synchronization between content editors and live previews using debounce and React refs</li>
         <li>🧹 Prevented memory leaks in embedded previews by properly cleaning up event listeners on component unmount</li>
         <li>💾 Efficiently persisted course content and user progress with throttled localStorage saving</li>

          </ul>
        </div>
      </div>
    </section>

    {/* System Architecture */}
    <section className="ninja-section">
      <h2>System Architecture</h2>
      <p>The following diagram shows high-level system architecture — how the UI interacts with storage and the preview sandbox.</p>
      <img
        src={Lms_Sys}
        alt="System Architecture Diagram"
        className="ninja-img"
      />
    </section>

    {/* DB Architecture */}
    <section className="ninja-section">
      <h2>DB & Data Flow</h2>
      <p>Diagram illustrating how code snippets and settings are stored and retrieved from LocalStorage.</p>
      <img
        src={Lms_DB}
        alt="Database Architecture Diagram"
        className="ninja-img"
      />
    </section>

    {/* Roadmap */}
    <section className="ninja-section">
      <h2>🔮 Future Roadmap</h2>
      <ul className="ninja-list">
      <li>Secure user authentication with cloud-based progress and data backups</li>
      <li>Shareable links for live classes, assignments, and learning resources</li>
      <li>Built-in course templates and a reusable learning materials library</li>

      </ul>
    </section>

    {/* Links */}
    <section className="ninja-section">
      <h2>Project Links</h2>
      <ul className="ninja-link-list">
        <li>
          <a href="https://e-learning-lms-xi.vercel.app/" target="_blank" rel="noopener noreferrer">
            Live Site
          </a>
        </li>
        <li>
          <a href="https://github.com/MemonaAmirAbdulHaq/ELearningLMS" target="_blank" rel="noopener noreferrer">
            GitHub Repository
          </a>
        </li>
      </ul>
    </section>
    <Footer />
  </div>
);
}
export default NinjaCaseStudy;
